import React, { createContext, useContext, useState, useCallback } from "react";
import { Snackbar, Alert, Slide } from "@mui/material";

const SnackbarContext = createContext();

export const useSnackbar = () => useContext(SnackbarContext);

const SlideTransition = (props) => <Slide {...props} direction="up" />;

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
    anchor: { vertical: "bottom", horizontal: "left" },
  });

  const openSnackbar = useCallback(
    (
      message,
      severity = "info",
      anchor = { vertical: "bottom", horizontal: "center" },
    ) => {
      setSnackbar({ open: true, message, severity, anchor });
    },
    [],
  );

  const closeSnackbar = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <SnackbarContext.Provider value={openSnackbar}>
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={8000}
        onClose={closeSnackbar}
        TransitionComponent={SlideTransition}
        anchorOrigin={snackbar.anchor}
        disableTransitionOnExit
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
